import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ScrollState {
  isAtTop: boolean;
  isAtBottom: boolean;
  scrollTop: number;
}

const initialState: ScrollState = {
  isAtTop: true,
  isAtBottom: false,
  scrollTop: 0
};

const scrollSlice = createSlice({
  name: 'scroll',
  initialState,
  reducers: {
    setScrollState(state, action: PayloadAction<ScrollState>) {
      state.isAtTop = action.payload.isAtTop;
      state.isAtBottom = action.payload.isAtBottom;
      state.scrollTop = action.payload.scrollTop;
    }
  }
});

export const { setScrollState } = scrollSlice.actions;
export default scrollSlice.reducer;
